package com.playoffpulse.frontend.data

import kotlinx.browser.window

fun defaultPlayoffDataProvider(): PlayoffDataProvider {
    return BackendApiProvider(baseUrl = FrontendRuntimeFlags.backendBaseUrl())
}

object FrontendRuntimeFlags {
    private const val BACKEND_BASE_URL_STORAGE_KEY = "playoffpulse.backend_base_url"
    private const val DEFAULT_BACKEND_BASE_URL = "/api/v1"

    fun backendBaseUrl(): String {
        val queryOverride = queryParam("backendBaseUrl")?.takeIf { it.isNotBlank() }
        if (queryOverride != null) return queryOverride.trimEnd('/')

        val localOverride = runCatching { window.localStorage.getItem(BACKEND_BASE_URL_STORAGE_KEY) }
            .getOrNull()
            ?.takeIf { it.isNotBlank() }
        if (localOverride != null) return localOverride.trimEnd('/')

        val globalOverride = runCatching {
            js("window.PLAYOFFPULSE_BACKEND_BASE_URL") as? String
        }.getOrNull()?.takeIf { it.isNotBlank() }
        if (globalOverride != null) return globalOverride.trimEnd('/')

        return DEFAULT_BACKEND_BASE_URL
    }

    private fun queryParam(name: String): String? {
        val search = window.location.search.removePrefix("?")
        if (search.isBlank()) return null

        return search.split("&")
            .asSequence()
            .map { it.trim() }
            .filter { it.isNotEmpty() }
            .map { token ->
                val splitAt = token.indexOf('=')
                if (splitAt < 0) {
                    token to ""
                } else {
                    token.substring(0, splitAt) to token.substring(splitAt + 1)
                }
            }
            .firstOrNull { it.first == name }
            ?.second
            ?.takeIf { it.isNotBlank() }
    }
}
